import userServices from "../../services/user";
import commonServices from "../../services/common";
import coreServices from "../../services/core";
import cipherServices from "../../web-sh/src/services/cipher";

import global from "../../config/global";
import common from ".";

const remakeBackupPWL = async (payload) => {
  const userInfo = global.store.getState().auth.userInfo;
  if (payload.pwl_id && userInfo) {
    if (
      payload.kdf !== userInfo.kdf ||
      payload.kdf_iterations !== userInfo.kdf_iterations ||
      payload.kdf_memory !== userInfo.kdf_memory ||
      payload.kdf_parallelism !== userInfo.kdf_parallelism
    ) {
      await common.serviceSetApiToken();
      const encKey = await global.jsCore.cryptoService.getEncKey();
      let remakeResponse = null;
      if (payload.unlock_method === 'security_key') {
        remakeResponse = await service.remakeBackupPasswordless({
          id: payload.pwl_id,
          email: userInfo.email,
          currentEncKey: encKey.key,
          secret: payload.password,
          kdf: userInfo.kdf,
          kdfIterations: userInfo.kdf_iterations,
          kdfMemory: userInfo.kdf_memory,
          kdfParallelism: userInfo.kdf_parallelism
        })
      } else if (payload.unlock_method === 'passkey') {
        remakeResponse = await service.remakeBackupPasswordlessUsingPasskey({
          id: payload.pwl_id,
          email: userInfo.email,
          currentEncKey: encKey.key,
          secret: payload.password,
          kdf: userInfo.kdf,
          kdfIterations: userInfo.kdf_iterations,
          kdfMemory: userInfo.kdf_memory,
          kdfParallelism: userInfo.kdf_parallelism
        })
      }
      if (remakeResponse) {
        await coreServices.logout();
        return remakeResponse;
      }
    }
  }
  return null;
}

const unlockToVault = async (
  payload = {
    hashedPassword,
    keyB64,
    password,
    username,
    email,
    unlock_method,
    pwl_id,
    kdf,
    kdf_iterations,
    kdf_memory,
    kdf_parallelism
  },
  query = null,
  callback = () => { }
) => {
  await userServices.users_session(payload).then(async (response) => {
    await common.updateSessionToken(response.access_token);
    await common.serviceSetApiToken();
    await coreServices.unlock({ ...response, ...payload });
    common.getPaymentPlan()
    await common.updateUnlockMethod(payload.unlock_method);
    if (response.has_no_master_pw_item && payload.password) {
      const encMasterPwItem = await common.createEncryptedMasterPw(payload.password)
      const { score } = common.getPasswordStrength(payload.password)
      await cipherServices.create({
        ...encMasterPwItem,
        score,
        collectionIds: []
      })
    }
    const remakeResponse = await remakeBackupPWL(payload);
    if (remakeResponse) {
      const newPayload = {
        ...payload,
        password: null,
        hashedPassword: remakeResponse.hashedPassword,
        keyB64: remakeResponse.key.keyB64,
        kdf: remakeResponse.kdf,
        kdf_iterations: remakeResponse.kdf_iterations,
        kdf_memory: remakeResponse.kdf_memory,
        kdf_parallelism: remakeResponse.kdf_parallelism
      }
      await unlockToVault(newPayload, query, callback)
    } else {
      const isSynced = await commonServices.sync_data();
      if (isSynced) {
        if (query) {
          callback();
        } else {
          global.navigate(global.keys.VAULT, {}, {}, true);
        }
      }
    }
  }).catch((error) => {
    global.pushError(error)
  })
}

export default {
  unlockToVault,
  remakeBackupPWL
}

